import React from 'react';
import { observer } from 'mobx-react-lite';
import { AccountDetails } from '@groma-dev/navigation';
import { classNames, getTestIdAttribute } from '@groma-dev/blueprint';
import { FormattedMessage } from 'react-intl';
import { HeaderMenu } from '../Header';
import { AppConfig } from '../../../../core/AppConfig';
import { useDataStore } from '../../../providers/StoresProvider';
import styles from './Menu.module.scss';

export interface MenuProps {
  section?: HeaderMenu;
  signOutUser?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const Menu = observer((props: MenuProps) => {
  const { section, signOutUser } = props;
  const dataStore = useDataStore();
  const { Domains } = AppConfig.Settings;

  switch (section) {
    default:
      return dataStore.userState.user ? (
        <div className={classNames(styles.accountContainer)}>
          <AccountDetails user={dataStore.userState.user} className={classNames(styles.menuItem, styles.account)} />
          <a
            href={Domains.id.baseUrl}
            className={classNames(styles.menuItem, styles.submenu)}
            {...getTestIdAttribute('mobileManageAccount')}>
            <FormattedMessage
              id="header.menu.profile"
              defaultMessage="Manage Profile"
              description="Menu manage profile nav item"
            />
          </a>
          <a
            href="/logout"
            className={classNames(styles.menuItem, styles.submenu)}
            onClick={signOutUser}
            {...getTestIdAttribute('mobileSignOut')}>
            <FormattedMessage id="header.menu.signOut" defaultMessage="Sign Out" description="Menu sign out nav item" />
          </a>
        </div>
      ) : null;
  }
});
